import React, { useEffect, useRef } from "react";
import { getYahooAdsUri } from "./yahooFeed";
import { toTitleCase } from "../commons/HelperFunctions";
import { useLanderConfig } from "../commons/ConfigContext";
import { sendYahooEvent, EventType } from "./yahooEvent";
import { trackImpression } from "../commons/signals";
import SearchIcon from "@ux/icon/search";
import ChevronRightIcon from "@ux/icon/chevron-right";
import "@ux/icon/search/index.css";
import "@ux/icon/chevron-right/index.css";

interface YahooRSProps {
  xmlResult: Document | null;
}

export const YahooRS: React.FC<YahooRSProps> = ({ xmlResult }) => {
  const config = useLanderConfig();
  const rootDomain = config.landerConfig.domain.rootDomain;
  const resultSet =
    xmlResult?.getElementById("relatedTerms")?.getElementsByTagName("Search") ??
    [];
  const yahooFeed = Array.from(resultSet);
  const hasEventFired = useRef(false);

  useEffect(() => {
    if (yahooFeed.length > 0 && !hasEventFired.current) {
      hasEventFired.current = true;
      const rsTerms = yahooFeed
        .map((item) => toTitleCase(item.innerHTML))
        .join(",");
      sendYahooEvent(EventType.RS_LOAD, config.landerConfig, { rsTerms });
      trackImpression({ section: "related_search", widget: "rs_block" });
    }
  }, [config.landerConfig, xmlResult, yahooFeed]);

  return (
    <div className="yahooRS">
      <div className="relatedTopicsHeader">
        <span>Related Search Topics</span>
      </div>
      <ul>
        {
          // create related link items
          yahooFeed &&
            yahooFeed.map((item: HTMLElement, itemIndex) => (
              <li key={ `yahoo-feed-item-${itemIndex}` }>
                <div className="iconContainer">
                  <SearchIcon
                    style={{ color: "black" }}
                    height="32"
                    width="32"
                  />
                </div>
                <a
                  href={ getYahooAdsUri({
                    qs: item.getAttribute("queryParams"),
                    rootDomain,
                    searchQuery: "",
                    system: config.landerConfig.system,
                    customerId: config.landerConfig.customerId,
                    typeTag: config.landerConfig.yahoo?.typeTag,
                  }) }
                >
                  {toTitleCase(item.innerHTML)}
                </a>
                <div style={{ minWidth: "32px" }}>
                  <ChevronRightIcon
                    style={{ color: "black" }}
                    height="32"
                    width="32"
                  />
                </div>
              </li>
            ))
        }
      </ul>
    </div>
  );
};
